import React from 'react';
import { roleConstants } from '../../constants/roleConstants';
import { PrivateRoute } from './PrivateRoute';

export const OfficerRoute = ({ ...props }) => {
  return <PrivateRoute {...props} role={roleConstants.ROLE_OFFICER} />;
};
